const DEFAULT_REFRESH_BUFFER_SECONDS = 60

const isSessionExpired = (session, bufferMs) => {
  if (!session || !session.expires_at) return false
  const expiryTime = session.expires_at * 1000
  return expiryTime <= Date.now() + bufferMs
}

const safeGetSession = async (supabaseClient) => {
  try {
    const { data, error } = await supabaseClient.auth.getSession()
    if (error) {
      console.warn("[Auth] getSession error", error)
    }
    return data?.session ?? null
  } catch (err) {
    console.warn("[Auth] getSession threw", err)
    return null
  }
}

const safeRefreshSession = async (supabaseClient) => {
  if (!supabaseClient?.auth?.refreshSession) return null
  try {
    const { data, error } = await supabaseClient.auth.refreshSession()
    if (error) {
      console.warn("[Auth] refreshSession error", error)
    }
    return data?.session ?? null
  } catch (err) {
    console.warn("[Auth] refreshSession threw", err)
    return null
  }
}

export const getValidSupabaseSession = async (
  supabaseClient,
  { refreshBufferSeconds = DEFAULT_REFRESH_BUFFER_SECONDS } = {}
) => {
  if (!supabaseClient?.auth?.getSession) return null

  const bufferMs = Math.max(0, refreshBufferSeconds) * 1000

  let session = await safeGetSession(supabaseClient)

  if (!session || isSessionExpired(session, bufferMs)) {
    const refreshed = await safeRefreshSession(supabaseClient)
    if (refreshed) {
      session = refreshed
    }
  }

  if (session && !isSessionExpired(session, bufferMs)) {
    return session
  }

  return null
}

export const getValidSupabaseAccessToken = async (
  supabaseClient,
  options = {}
) => {
  const session = await getValidSupabaseSession(supabaseClient, options)
  return session?.access_token || null
}

